import { theme } from '../constants/defaults';
import { getDetailsCount, getNumberOfResultsString } from '../utils/search';

function renderProductImage(product) {
  if (product.image === null || product.image === undefined) {
    return '';
  }

  return `
    <div class="placeholder-background placeholder-background--animation" data-image-placeholder aria-hidden="true"></div>
    <img class="predictive-search-item__image lazyload"
      src="${product.image.url}"
      data-src="${product.image.url}"
      data-image
      alt="${product.image.alt}"
    />
  `;
}

function renderVendor(product) {
  if (!theme.settings.searchShowVendor || product.vendor === '') {
    return '';
  }

  return `
    <dt class="vh">${theme.strings.vendor}</dt>
    <dd class="predictive-search-item__vendor">${product.vendor}</dd>
  `;
}

function renderCompareAtPrice(product) {
  return `
    <dt class="vh">${theme.strings.regularPrice}</dt>',
    <dd>
      <span class="predictive-search-item__price predictive-search-item__price--compare">
        ${product.compareAtPrice}
      </span>
    </dd>
  `;
}

function renderPrice(product) {
  return `
    <dt class="vh">${theme.strings.regularPrice}</dt>
    <dd>
      <span class="predictive-search-item__price">${
        product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace('[price]', product.price)
          : product.price
      }</span>
    </dd>
  `;
}

function renderSalePrice(product) {
  return `
    <dt class="vh">${theme.strings.salePrice}</dt>
    <dd>
      <span class="predictive-search-item__price predictive-search-item__price--sale">
        ${
          product.isPriceVaries
            ? theme.strings.fromLowestPrice.replace('[price]', product.price)
            : product.price
        }
      </span>
    </dd>
    <div class="price__compare">
      ${renderCompareAtPrice(product)}
    </div>
  `;
}

function renderProductPrice(product) {
  if (!theme.settings.searchShowPrice) {
    return '';
  }

  const accessibilityAnnounceComma = '<span class="vh">, </span>';
  const priceMarkup = `<div class="price__regular">${renderPrice(product)}</div>`;
  const salePriceMarkup = `<div class="price__sale">${renderSalePrice(product)}</div>`;

  return `${accessibilityAnnounceComma}<div class="price__pricing-group">${
    product.isOnSale ? salePriceMarkup : priceMarkup
  }</div>`;
}

function renderProductDetails(product) {
  return `
    <dl class="predictive-search-item__details price${product.isOnSale ? ' price--on-sale' : ''}${
    !product.available ? ' price--sold-out' : ''
  }${!product.isPriceVaries && product.isCompareVaries ? ' price--compare-price-hidden' : ''}">
      <div class="predictive-search-item__detail">
        ${renderVendor(product)}
      </div>
      <div class="predictive-search-item__detail predictive-search-item__detail--inline">
        ${renderProductPrice(product)}
      </div>
    </dl>
  `;
}

function renderItemImageSection(product) {
  if (product.image === null || product.image === undefined) {
    return ' ';
  }

  return `
    <div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper>
      ${renderProductImage(product)}
    </div>`;
}

export default (product, index, resultsCount) => `
    <li id="search-result-${index}" class="predictive-search-item" role="option" data-search-result>
      <a class="predictive-search-item__link" href="${product.url}" tabindex="-1">
        ${renderItemImageSection(product)}
        <div class="predictive-search__column predictive-search__column--content ${
          getDetailsCount() ? '' : 'predictive-search__column--center'
        }">
          <span class="predictive-search-item__title">
            <span class="predictive-search-item__title-text">${product.title}</span>
          </span>
          ${getDetailsCount() ? renderProductDetails(product) : ''}
          <span class="vh">, </span>
          <span class="vh">${getNumberOfResultsString(index + 1, resultsCount)}</span>
        </div>
      </a>
    </li>
  `;
